import { isInvitationExpired } from '../../../shared/utils/invitationExpiry.js';
import { API_INVITATION_STATUS, LINK_STATE } from '../constants/invitationStates.js';

const normalize = (email) => String(email ?? '').trim().toLowerCase();
const isOtherAccount = (invited, signedIn) =>
  Boolean(normalize(invited)) && Boolean(normalize(signedIn)) && normalize(invited) !== normalize(signedIn);

/**
 * Which screen an invitation link gets. Revoked, unknown and malformed links share the neutral
 * "not valid" state on purpose: the recipient is not told which one it was.
 *
 * A valid link opened while signed in as someone else (`signedInEmail` differs from the invited
 * address) gets its own state: accepting it with the wrong account must not be possible.
 *
 * @param {{ status: string, expires_at?: string, invited_email?: string }|null} invitation Public API view, or null when not found.
 * @param {Date} [now]
 * @param {{ signedInEmail?: string|null }} [options]
 */
export const getInvitationLinkState = (invitation, now = new Date(), { signedInEmail } = {}) => {
  if (!invitation) return LINK_STATE.INVALID;
  switch (invitation.status) {
    case API_INVITATION_STATUS.PENDING:
      if (isInvitationExpired(invitation.expires_at, now)) return LINK_STATE.EXPIRED;
      return isOtherAccount(invitation.invited_email ?? invitation.invitedEmail, signedInEmail)
        ? LINK_STATE.OTHER_ACCOUNT
        : LINK_STATE.VALID;
    case API_INVITATION_STATUS.EXPIRED:
      return LINK_STATE.EXPIRED;
    case API_INVITATION_STATUS.ACCEPTED:
      return LINK_STATE.USED;
    default:
      return LINK_STATE.INVALID;
  }
};
